var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { html } from 'lit-html';
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { isNil, uniqueId } from 'lodash-es';
import '../../../input/time-picker/sds-time-picker-input.lit';
import '../../../input/time/sds-input-time.lit';
import '../../../switcher/sds-switcher-item.lit';
import '../../../switcher/sds-switcher.lit';
import { DayPeriod } from '../../enums/day-period.enum';
import { getElementById, getStringValue, parseHour } from '../../utils/time.util';
import styles from './sds-time-picker-content.lit.scss';
import { sdsCustomElement } from '../../../utilities/custom-components';
let SdsTimePickerContent = (() => {
    var _SdsTimePickerContent_format_accessor_storage, _SdsTimePickerContent_hour_accessor_storage, _SdsTimePickerContent_minute_accessor_storage, _SdsTimePickerContent__ampm_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-time-picker-content')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _format_decorators;
    let _format_initializers = [];
    let _format_extraInitializers = [];
    let _hour_decorators;
    let _hour_initializers = [];
    let _hour_extraInitializers = [];
    let _minute_decorators;
    let _minute_initializers = [];
    let _minute_extraInitializers = [];
    let __ampm_decorators;
    let __ampm_initializers = [];
    let __ampm_extraInitializers = [];
    var SdsTimePickerContent = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsTimePickerContent_format_accessor_storage.set(this, __runInitializers(this, _format_initializers, 24));
            _SdsTimePickerContent_hour_accessor_storage.set(this, (__runInitializers(this, _format_extraInitializers), __runInitializers(this, _hour_initializers, void 0)));
            _SdsTimePickerContent_minute_accessor_storage.set(this, (__runInitializers(this, _hour_extraInitializers), __runInitializers(this, _minute_initializers, void 0)));
            this._hourId = (__runInitializers(this, _minute_extraInitializers), uniqueId('sds-time-picker-hour'));
            this._minuteId = uniqueId('sds-time-picker-minute');
            _SdsTimePickerContent__ampm_accessor_storage.set(this, __runInitializers(this, __ampm_initializers, void 0));
            this._hour = __runInitializers(this, __ampm_extraInitializers);
            this.setDayPeriod = (event) => {
                this._ampm = event.detail.selected;
                this.dispatchChange();
            };
            this.dispatchChange = () => {
                if (this.shadowRoot) {
                    this._hour = getElementById(this._hourId, this.shadowRoot).value;
                    this.hour = parseHour(+this._hour, this._ampm);
                    this._minute = getElementById(this._minuteId, this.shadowRoot).value;
                    this.minute = +this._minute;
                }
                this.dispatch(this.getDetail());
            };
        }
        get format() { return __classPrivateFieldGet(this, _SdsTimePickerContent_format_accessor_storage, "f"); }
        set format(value) { __classPrivateFieldSet(this, _SdsTimePickerContent_format_accessor_storage, value, "f"); }
        get hour() { return __classPrivateFieldGet(this, _SdsTimePickerContent_hour_accessor_storage, "f"); }
        set hour(value) { __classPrivateFieldSet(this, _SdsTimePickerContent_hour_accessor_storage, value, "f"); }
        get minute() { return __classPrivateFieldGet(this, _SdsTimePickerContent_minute_accessor_storage, "f"); }
        set minute(value) { __classPrivateFieldSet(this, _SdsTimePickerContent_minute_accessor_storage, value, "f"); }
        get _ampm() { return __classPrivateFieldGet(this, _SdsTimePickerContent__ampm_accessor_storage, "f"); }
        set _ampm(value) { __classPrivateFieldSet(this, _SdsTimePickerContent__ampm_accessor_storage, value, "f"); }
        attributeChangedCallback(name, _old, value) {
            super.attributeChangedCallback(name, _old, value);
            this.initValues();
        }
        connectedCallback() {
            super.connectedCallback();
            this.initValues();
        }
        render() {
            return html `
            <div class="sds-time-picker__content" part="sds-time-picker">
                <div class="sds-time-picker__inputs">
                    <sds-time-picker-input
                        class="${this.getInputClasses()}"
                        id="${this._hourId}"
                        value="${this._hour}"
                        maxValue="${this.format === 12 ? 12 : 23}"
                        minValue="${this.format === 12 ? 1 : 0}"
                        @sds.input.changed="${this.dispatchChange}"
                    ></sds-time-picker-input>
                    <div class="${this.getClasses()}">:</div>
                    <sds-time-picker-input
                        class="${this.getInputClasses()}"
                        id="${this._minuteId}"
                        value="${this._minute}"
                        maxValue="59"
                        minValue="0"
                        @sds.input.changed="${this.dispatchChange}"
                    ></sds-time-picker-input>
                </div>
                ${this.getDatePeriodSwitcher()}
            </div>
        `;
        }
        getClasses() {
            return classMap({
                'sds-time-picker__separator': true,
                'sds-time-picker__separator--sm': this.format !== 12,
            });
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        getInputClasses() {
            return classMap({
                'sds-time-picker__input': true,
                'sds-time-picker__input--sm': this.format === 12,
            });
        }
        dispatch(value) {
            this.dispatchEvent(new CustomEvent(SdsTimePickerContent.CHANGE_EVENT, {
                detail: { value },
                bubbles: false,
                composed: false,
            }));
        }
        getDetail() {
            if (!isNil(this.hour) && !isNil(this.minute)) {
                return {
                    hour: this.hour,
                    minute: this.minute,
                };
            }
            return null;
        }
        getDatePeriodSwitcher() {
            if (this.format !== 12) {
                return html ``;
            }
            return html ` <sds-switcher
            selected="${this._ampm}"
            @sds.switcher.changed="${this.setDayPeriod}"
        >
            <sds-switcher-item
                value="${DayPeriod.ANTE}"
                label="${DayPeriod.ANTE}"
            ></sds-switcher-item>
            <sds-switcher-item
                value="${DayPeriod.POST}"
                label="${DayPeriod.POST}"
            ></sds-switcher-item>
        </sds-switcher>`;
        }
        initValues() {
            if (this.format === 12) {
                this._ampm = !this.hour || 12 - this.hour > 0 ? DayPeriod.ANTE : DayPeriod.POST;
                this._hour = getStringValue(this.hour && this.hour !== 12 ? this.hour % 12 : 12);
            }
            else {
                this._hour = getStringValue(this.hour);
            }
            this._minute = getStringValue(this.minute);
        }
    };
    _SdsTimePickerContent_format_accessor_storage = new WeakMap();
    _SdsTimePickerContent_hour_accessor_storage = new WeakMap();
    _SdsTimePickerContent_minute_accessor_storage = new WeakMap();
    _SdsTimePickerContent__ampm_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTimePickerContent");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _format_decorators = [property({ type: Number })];
        _hour_decorators = [property({ type: Number, reflect: true })];
        _minute_decorators = [property({ type: Number, reflect: true })];
        __ampm_decorators = [state()];
        __esDecorate(_classThis, null, _format_decorators, { kind: "accessor", name: "format", static: false, private: false, access: { has: obj => "format" in obj, get: obj => obj.format, set: (obj, value) => { obj.format = value; } }, metadata: _metadata }, _format_initializers, _format_extraInitializers);
        __esDecorate(_classThis, null, _hour_decorators, { kind: "accessor", name: "hour", static: false, private: false, access: { has: obj => "hour" in obj, get: obj => obj.hour, set: (obj, value) => { obj.hour = value; } }, metadata: _metadata }, _hour_initializers, _hour_extraInitializers);
        __esDecorate(_classThis, null, _minute_decorators, { kind: "accessor", name: "minute", static: false, private: false, access: { has: obj => "minute" in obj, get: obj => obj.minute, set: (obj, value) => { obj.minute = value; } }, metadata: _metadata }, _minute_initializers, _minute_extraInitializers);
        __esDecorate(_classThis, null, __ampm_decorators, { kind: "accessor", name: "_ampm", static: false, private: false, access: { has: obj => "_ampm" in obj, get: obj => obj._ampm, set: (obj, value) => { obj._ampm = value; } }, metadata: _metadata }, __ampm_initializers, __ampm_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTimePickerContent = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CHANGE_EVENT = 'sds.date-time-content.changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTimePickerContent = _classThis;
})();
export { SdsTimePickerContent };
